import { core } from '@icc/shared/helpers';
import { IWindowConfiguration } from '../window-configuration';
import { DoorConfiguration } from '../door-configuration';

export function changesInVersion21(
    oldConfiguration: any,
): IWindowConfiguration {
    const configuration: IWindowConfiguration = {
        ...core.copy(oldConfiguration),
    };

    if (configuration.type === 'door') {
        (configuration as DoorConfiguration).components = {
            fullDoor: true,
            activeSash: true,
            passiveSash: true,
            frame: true,
            threshold: true,
            hardware: true,
            sideLight: {
                left: true,
                right: true,
                top: true,
            },
            extension: {
                left: true,
                right: true,
                top: true,
            },
            bottomExtension: true,
            portal: true,
            casing: true,
            accessories: true,
            pull: true,
            recessedPull: true
        }
    }

    return configuration;
}


